// extracted by mini-css-extract-plugin
module.exports = {"promoBanner":"PromoBanner_promoBanner__L8q_D"};